var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "pin",
    viewBox: "0 0 640 640",
    fill: "none",
    stroke: "#666",
    strokeWidth: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M595.2,252.3L384.1,41.1c-6.2-6.2-16.2-6.2-22.5,0l-14.1,14.1c-4.3,4.3-5.7,10.5-3.9,16.2l26.9,82.1c1.9,5.7,0.4,12-3.9,16.2l-70.1,70.1c-2.9,2.9-6.9,4.7-11.2,4.7l-182.1,0.9c-14.1,0.1-21.2,17.2-11.2,27.1l272,272c10,10,27.1,2.9,27.1-11.2l0.4-182.9c0-4.2,1.7-8.3,4.7-11.2l70.3-70.3c4.3-4.3,10.5-5.7,16.2-3.9l82.6,27.3c5.7,1.9,12,0.4,16.2-3.9l13.8-13.8C601.5,268.6,601.5,258.6,595.2,252.3z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    x1: 230.2,
    y1: 410.8,
    x2: 75,
    y2: 566
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.88eba08ac4badf667f2ea064ea8ab5f2.svg";
export { ForwardRef as ReactComponent };